











import {Component, Prop} from 'vue-property-decorator';
import Vue from 'vue';

    @Component({})
    export default class FormNavigationButton extends Vue {
        @Prop({ type: String, required: true}) sectionName!: string
        @Prop({ type: Boolean, default: true}) active!: boolean
        @Prop({ type: Number, default: 1}) pageNum!: number
        @Prop({ type: [String, Array], default: () => []}) inputClass!: string | string[]

        get appendedInputClass(): string[] {
            return (!Array.isArray(this.inputClass)) ? this.inputClass.split(' ') : this.inputClass;
        }
    }
